<template>
  <div>
    <el-form :inline="true" :model="searchForm">
      <el-form-item label="ICCID号：">
        <el-input
          v-model.trim="searchForm.iccid"
          @keyup.enter.native="getpollingNotStopList"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="处理状态">
        <el-select
          v-model="searchForm.disposeState"
          placeholder="请选择"
          clearable
          filterable
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="btnArea">
        <el-button type="primary" @click="getpollingNotStopList">搜索查询</el-button>
        <el-button type="primary" @click="showOptionTable">批量转卡</el-button>
        <el-button type="primary" @click="exportHandle">导出</el-button>
        <el-button type="primary" @click="clearDataHandle">清空数据</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tbpg.tableData" border>
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column prop="iccid" label="ICCID号"></el-table-column>
      <el-table-column prop="disposeName" label="处理人"></el-table-column>
      <el-table-column prop="createTime" label="创建时间"></el-table-column>
      <el-table-column prop="disposeState" label="处理状态"
        ><template slot-scope="scope">{{
          scope.row.disposeState == 1 ? "成功" : "失败"
        }}</template>
      </el-table-column>
      <el-table-column prop="disposeRemak" label="备注"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="tbpg.currentPage"
      :page-sizes="[15, 50, 100, 500]"
      :page-size="tbpg.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="tbpg.total"
    >
    </el-pagination>

    <el-dialog
      :append-to-body="true"
      title="批量变更状态"
      :visible.sync="isshowOptionTable"
      width="600px"
      @close="cancel"
      :close-on-click-modal="false"
    >
      <el-form
        ref="pollingNotStopFrom"
        :model="pollingNotStopFrom"
        label-width="100px"
      >
        <el-form-item label="导入Excel：" prop="uploadExcel">
          <el-upload
            ref="upload"
            :action="uploadUrl('batch/change/import/sim/no/stop?')"
            :headers="setHeader()"
            :auto-upload="false"
            :data="pollingNotStopFrom"
            :on-change="handleChange"
            :on-success="handleSuccess"
          >
            <el-button slot="trigger" plain>导入Excel</el-button>
            <el-button
              style="margin-left: 10px;"
              plain
              @click="exportExcel('/mould/download?type=changeState')"
              >导出模板</el-button
            >
          </el-upload>
        </el-form-item>

        <el-form-item label="导入类型：" prop="moveType">
          <el-radio v-model="pollingNotStopFrom.moveType" label="1"
            >增加</el-radio
          >
          <el-radio v-model="pollingNotStopFrom.moveType" label="2"
            >删除</el-radio
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="sureBatchChgStateHandler"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {pollingNotStopList, deletePollingNotStop, clearDataHandle} from "@/api/sim.js";
import common from "@/utils/common.js";

export default {
  data() {
    return {
      searchForm: {
        iccid: "",
        disposeState: null,
      },
      options: [
        {
          value: "1",
          label: "成功",
        },
        {
          value: "2",
          label: "失败",
        },
      ],
      tbpg: {
        tableData: [],
        currentPage: 1,
        pageSize: 15,
        total: 0,
      },
      isshowOptionTable: false,
      pollingNotStopFrom: {
        moveType: "1",
      },
    };
  },
  methods: {
    getpollingNotStopList($event) {
      common.resetCurrentPage(this, $event, "tbpg");
      var data = common.getRequestParams(this, "tbpg", this.searchForm);
      pollingNotStopList(data).then((res) => {
        common.listCallback(this, res, "tbpg");
      });
    },
    handleSizeChange(val) {
      this.tbpg.pageSize = val;
      this.getpollingNotStopList();
    },
    handleCurrentChange(val) {
      this.tbpg.currentPage = val;
      this.getpollingNotStopList();
    },
    showOptionTable() {
      this.isshowOptionTable = true;
    },
    cancel() {
      this.isshowOptionTable = false;
      this.$refs.pollingNotStopFrom.resetFields();
    },
    handleChange(file, fileList) {
      console.log(file);
      console.log(fileList);
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    handleSuccess(res) {
      if (res.code == 200) {
        this.getpollingNotStopList();
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
      this.cancel();
      this.$refs.upload.clearFiles();
    },
    sureBatchChgStateHandler() {
      this.$refs.pollingNotStopFrom.validate((valid) => {
        if (valid) {
          this.$refs.upload.submit();
        }
      });
    },
    handleDelete(index, row) {
      var data = {
        iccid: row.iccid,
      };
      deletePollingNotStop(data).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: res.data.message,
            type: "success",
          });
          this.getpollingNotStopList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 导出
    exportHandle() {
      var data = JSON.parse(JSON.stringify(this.searchForm));
      data.token = localStorage.getItem("token");
      this.exportExcel("/mould/download/stop/sim", data);
      this.$message.success("下载中……");
    },
    // 清空数据
    clearDataHandle() {
      this.$confirm('该操作将清除所有轮训不停机数据, 确定清除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: "warning",
          center: true
        }).then(() => {
          let data = {}
          clearDataHandle(data).then(res => {
            if (res.data.code == 200) {
              this.$message({
                message: res.data.message,
                type: 'success'
              });
            }
            else {
              this.$message({
                  message: '警告哦，这是一条警告消息',
                  type: 'warning'
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: "info",
            message: '已取消删除'
          });
        });
    }
  },
  created() {
    this.getpollingNotStopList();
  },
};
</script>

<style></style>
